import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy(event) {
    event.preventDefault()
    const text = this.textValue

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => this.showFeedback())
        .catch(() => this.fallbackCopy(text))
    } else {
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()
    try {
      document.execCommand("copy")
      this.showFeedback()
    } catch {
      // last resort: prompt user to copy manually
      window.prompt("URL을 복사하세요:", text)
    }
    document.body.removeChild(textarea)
  }

  showFeedback() {
    const original = this.element.textContent
    this.element.textContent = "복사됨!"
    setTimeout(() => { this.element.textContent = original }, 2000)
  }
}
